import { RefObject, useCallback } from 'react';

export function useTimelineControls(
  timelineRef: RefObject<HTMLDivElement>,
  duration: number,
  onSeek: (time: number) => void
) {
  const getTimeFromPosition = useCallback((clientX: number) => {
    if (!timelineRef.current) return 0;

    const rect = timelineRef.current.getBoundingClientRect();
    const position = clientX - rect.left;
    const percentage = position / rect.width;
    return Math.max(0, Math.min(duration, percentage * duration));
  }, [duration]);

  const handleTimelineClick = useCallback((e: React.MouseEvent) => {
    const time = getTimeFromPosition(e.clientX);
    onSeek(time);
  }, [getTimeFromPosition, onSeek]);

  const handleTimelineMouseMove = useCallback((e: React.MouseEvent) => {
    const time = getTimeFromPosition(e.clientX);
    // Optional: Add hover preview functionality here
  }, [getTimeFromPosition]);

  return {
    handleTimelineClick,
    handleTimelineMouseMove,
    getTimeFromPosition
  };
}